export const datapointIdToString = (datapointId) => {
    if (datapointId.standard) {
        return datapointId.standard.toString();
    }
    return datapointId?.custom?.toString() ?? null;
};
export const datapointRequestElementNameToString = (datapointRequestElement) => {
    if (datapointRequestElement.standardDatapoint) {
        return datapointRequestElement.standardDatapoint.toString();
    }
    return datapointRequestElement?.customDatapoint ?? null;
};
